<template>
  <div :class="gridClasses" :style="gridStyle" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
    <div class="grid-item-inner ">
      <transition name="fade" mode="out-in">
        <div v-if="!isHovered">
          <h3 class="sponsorGrid-kid-title">{{ child.name }}</h3>
          <div class="sponsorCard-meta">
            <div class="sponsorCard-meta-icon">
              <img src="/wp-content/themes/pfi/dist/svg/sponsorCard-country-white.svg" alt="">
            </div>
            <div class="sponsorCard-meta-text">{{ child.country }}</div>
          </div>
        </div>
        <a class="btn btn-yellow" :href="child.link" v-else>Learn More</a>
      </transition>
    </div>
  </div>
</template>

<script>
import { sample } from 'lodash';

export default {
  name: 'GridItem',
  props: {
    child: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isHovered: false,
    };
  },
  computed: {
    gridClasses() {
      const baseClasses = [ 'mosaic-grid-item' ];
      const colorClasses = [
        'overlay-blue',
        'overlay-green',
        'overlay-orange',
        'overlay-yellow',
      ];

      console.log('GridItem overlayClasses', baseClasses.concat(sample(colorClasses)).join(' '));
      return baseClasses.concat(sample(colorClasses)).join(' ');
    },
    gridStyle() {
      return {
        backgroundImage: `url(${this.child.photo})`,
      };
    },
  },
};
</script>

<style></style>
